import { render, staticRenderFns } from "./DesktopRoad.vue?vue&type=template&id=29c3a97b&scoped=true&"
import script from "./DesktopRoad.vue?vue&type=script&lang=js&"
export * from "./DesktopRoad.vue?vue&type=script&lang=js&"
import style0 from "./DesktopRoad.vue?vue&type=style&index=0&id=29c3a97b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c3a97b",
  null
  
)

export default component.exports